/**
 * Calculate the center slide index for a carousel
 * @param totalItems - Total number of items in the carousel
 * @returns The index of the center slide (middle item)
 */
export function getCenterSlideIndex(totalItems: number): number {
  if (totalItems === 0) return 0;
  return Math.floor(totalItems / 2);
}

